/* eslint-disable no-console */
export const logs = (...logs: unknown[]) => {
  if (process.env.REACT_APP_ENV === "DEV") console.log(...logs);
};

export const debug = (...logs: unknown[]) => {
  if (process.env.REACT_APP_ENV === "DEV") console.debug(...logs);
};

export const error = (...logs: unknown[]) => {
  if (process.env.REACT_APP_ENV === "DEV") console.error(...logs);
};

/* Custom logger that logs only in DEV env */
export const logger = {
  logs,
  error,
  debug,
};
